<template>
  <div class="base-table-list" ref="base-table-list">
    <el-table :data="tableData" @select="checkItem" @select-all="selectAll" style="width: 100%" ref="table" key="table" :border="border" :height="height || '100%'" v-el-table-infinite-scroll="scrollLoad" row-key="id" :default-sort="defaultSort" v-if="readerTime" :row-class-name="setRow" :empty-text="''" :select-on-indeterminate="isSelectAll" fit v-loading="(loading && tableData.length === 0) || isShowPage ? loading : false" @row-click="rowClick">
      <template slot="empty">
        <nothing :config="config" v-if="!loading && tableData.length === 0"></nothing>
      </template>
      <el-table-column type="selection" v-if="isSelect && !isDisabledProject" width="55">
        <template slot-scope="scope">
          <img v-if="scope.row.loading" src="./img/loading.svg" class="el-icon-loading file-table-loading" alt="" />
          <el-checkbox v-else v-model="scope.row.checked"></el-checkbox>
        </template>
      </el-table-column>
      <template v-for="item in tableHead">
        <el-table-column :prop="item.key" :key="item.key" :label="item.name" v-if="$scopedSlots[item.key]" :sortable="item.sortable" :width="item.width || 'auto'" :sort-method="item.sortMethods || null" :min-width="item.minWidth" :fixed="item.fixed">
          <template slot="header" slot-scope="scope">
            <slot :name="'header_' + item.key" :row="scope.row" :index="scope.$index">
              <span>{{ item.name }}</span>
            </slot>
          </template>
          <template slot-scope="scope">
            <slot :name="item.key" :row="scope.row" :index="scope.$index"></slot>
          </template>
        </el-table-column>
        <template v-else>
          <el-table-column :prop="item.key" :key="item.key" :label="item.name" :sortable="item.sortable" :formatter="item.formatter || null" :width="item.width || 'auto'" :min-width="item.minWidth" :sort-method="item.sortMethods || null" :fixed="item.fixed">
            <template slot-scope="scope">
              <ToolTip style="width: 100%" :title="getKeyList(scope.row, item.key)">
                {{ getKeyList(scope.row, item.key) }}
              </ToolTip>
            </template>
          </el-table-column>
        </template>
      </template>
      <el-table-column v-if="toolObj.length > 0" label="操作" :fixed="fixed ? 'right' : false" :width="getBtnWidth">
        <template slot-scope="scope">
          <div class="btns-label" @click.stop>
            <div class="btns">
              <span v-for="item in outBtn(scope.row)" class="item-child" :class="{ del: item.value === 'del', 'text-disable': item.hasClick ? item.hasClick(scope.row) : false }" @click.stop="btnCheck(item, scope.row)" :key="item.value">{{ item.label }}</span>
            </div>
            <el-popover placement="bottom" v-if="inBtn(scope.row) && inBtn(scope.row).length > 0" popper-class="info-file-able" :ref="'gridTable' + scope.row.id" :key="scope.row.id" trigger="click">
              <div slot="reference">
                <span class="more-search" @click="closeThisDialog('gridTable' + scope.row.id)">更多</span>
              </div>
              <div class="item-box">
                <div v-for="item in inBtn(scope.row)" :key="item.value" class="item-child" :class="{ del: item.value === 'del', 'text-disable': item.hasClick ? item.hasClick(scope.row) : false }" @click.stop="btnCheck(item, scope.row)"><i :class="`icon iconfont ${item.icon}`"></i>{{ item.value === "del" ? (scope.row.type === 1 ? "删除文件夹" : "删除文件") : item.label }}</div>
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <div class="shard-loading-table__box" slot="append">
        <div class="shard-loading-table" v-if="!finish && tableData.length > 0 && !isShowPage">
          <div v-loading="true"></div>
        </div>
      </div>
    </el-table>
    <div class="my-scroll" ref="scroll" :style="{ width: width_box + 'px', left: table_offsetLeft + 'px' }" @scroll="onScroll">
      <div class="my-scroll-in" :style="{ width: width_in + 'px' }"></div>
    </div>
    <div ref="pagination-block" class="pagination-block" v-if="isShowPage && pagData.total > pagData.number">
      <el-pagination style="float: right" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagData.page" :page-sizes="pagData.pageSizes" :page-size="pagData.number" :layout="pagData.layout" :total="pagData.total"> </el-pagination>
    </div>
    <!-- 弹窗提示 -->
    <!-- <AlertDialog title="所选文件夹不为空，不能执行删除操作。" v-model="alertDialog"></AlertDialog> -->
  </div>
</template>
<script>
// import AlertDialog from './alertDialog'
import elTableInfiniteScroll from "el-table-infinite-scroll";
import { mapState, mapMutations } from "vuex";
import elementResizeDetectorMaker from "element-resize-detector";
export default {
  props: {
    ruleForm: Object,
    tableData: Array,
    height: [Number, String, Boolean],
    loading: Boolean,
    finish: Boolean,
    isSelect: Boolean,
    sall: Boolean,
    fixed: Boolean,
    btnWidth: {
      type: String,
      default: "180px",
    },
    config: {
      type: Object,
      default: () => {},
    },
    isShowPage: Boolean,
    toolObj: {
      type: Array,
      default: () => [],
    },
    showDetail: {
      type: Boolean,
      default: true,
    },
    tableHead: {
      type: Array,
      default: () => [],
    },
    defaultSort: {
      // 默认排序
      type: Object,
      default: () => {
        return {};
      },
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // AlertDialog
  },
  directives: {
    "el-table-infinite-scroll": elTableInfiniteScroll,
  },
  data() {
    return {
      dataset: {},
      restnameVisible: false,
      alertDialog: false,
      deldialogVisible: false,
      popoverShow: false,
      isSelectAll: false,
      outBtnIsHave: true,
      inBtnIsHave: true,
      width_box: 0,
      width_in: 0,
      erd: null,
      table_offsetLeft: 0,
      delTip: {
        title: "是否确认删除？",
        tip: "",
      },
      readerTime: true,
      pagData: {
        // 分页参数
        page: 1, // 页码
        pageSizes: [20, 50, 100], // 每页条数类型
        number: 20, // 每页显示条数
        layout: "prev, pager, next, sizes, total", // 布局
        total: 0, // 总页数
      },
      isClickPopover: "",
    };
  },
  mounted() {
    if (this.sall) {
      this.$refs.table.toggleAllSelection();
    } else {
      this.tableData.forEach((res) => {
        if (res.checked) {
          this.$refs.table.toggleRowSelection(res, true);
        }
      });
    }
    if (this.isShowPage) {
      this.load();
    }
    this.erd = elementResizeDetectorMaker();
    this.erd.listenTo(this.$refs.table.$el, async (ele) => {
      this.setScrollBottom();
    });
  },
  computed: {
    getBtnWidth() {
      return this.btnWidth;
    },
    outBtn() {
      return (data) => {
        let arr = this.toolObj.filter((res) => {
          return !res.permissions || res.permissions(data);
        });
        if (arr.length > 0) {
          this.outBtnIsHave = true;
          return arr.slice(0, 1);
        } else {
          this.outBtnIsHave = false;
          return [];
        }
      };
    },
    inBtn() {
      return (data) => {
        let arr = this.toolObj.filter((res) => {
          return !res.permissions || res.permissions(data);
        });
        if (arr.length > 1) {
          this.inBtnIsHave = true;
          return arr.slice(1);
        } else {
          this.inBtnIsHave = false;
          return [];
        }
      };
    },
    ...mapState('task/task', {
      isDisabledProject: state => state.isDisabledProject
    })
  },
  watch: {
    isSelect() {
      this.readerTime = false;
      setTimeout(() => {
        this.readerTime = true;
      }, 100);
    },
    tableData: {
      handler() {
        this.$nextTick(() => {
          this.$refs.table.clearSelection();
          this.tableData.map((res) => {
            if (res.checked && this.$refs.table) {
              this.$refs.table.toggleRowSelection(res, res.checked);
            }
          });
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("info/info", ["ADD_TAG"]),
    move(id) {
      this.$emit("move", id);
    },
    init() {
      this.pagData.page = 1;
      this.pagData.total = 0;
      this.load();
    },
    restName(data) {
      this.$emit("restName", data);
    },
    delFolde(data) {
      // 删除文件夹
      this.$emit("delFile", data);
    },
    scrollLoad() {
      if (!this.isShowPage) {
        this.load();
      }
    },
    load() {
      if (this.loading || this.finish) return;
      this.$emit("load", this.pagData);
    },
    selectAll(data) {
      console.log(data);
      // this.tableData.forEach(res => {
      //   if(res.type === 2){
      //     console.log(res.checked)
      //     this.$refs.table.toggleRowSelection(res, res.checked)
      //   }
      // })
      this.$emit("selectAll", data.length > 0);
    },
    checkItem(row) {
      // let fl = Boolean(selection.find((res) => res.id === row.id));
      this.$emit("change", { checked: fl, id: row.id });
    },
    uploadNewFile(data) {
      this.$emit("uploadNewFile", data);
    },
    setAMOS(isMark, data) {
      // 标记AMOS
      this.$emit("setAMOS", { isMark, data });
    },
    btnCheck(item, row) {
      this.$refs.gridTable ? this.$refs.gridTable.doClose() : "";
      item.fn(row);
    },
    setRow({ row }) {
      if (row.type === 1) {
        // 在项目的文件tab状态下，文件列表中的文件夹也是可以被多选选中(修改于 23-06-14)
        // return "hidden-select";
      }
    },
    downFile(row) {
      this.$emit("down", row);
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    handleSizeChange(data) {
      this.pagData.number = data;
      this.load();
    },
    handleCurrentChange(data) {
      this.pagData.page = data;
      this.load();
    },
    getKeyList(row, key) {
      if (key.indexOf(".") > -1) {
        let arr = key.split(".");
        let result = JSON.parse(JSON.stringify(row));
        for (let i = 0; i < arr.length; i++) {
          if (!result[arr[i]]) {
            return "-";
          } else {
            result = result[arr[i]];
          }
        }
        return result;
      } else {
        return row[key] === "" || row[key] === null || row[key] === undefined ? "-" : row[key];
      }
    },
    rowClick(row) {
      this.$emit("row-click", row);
    },
    setScrollBottom() {
      this.$nextTick(() => {
        let width_t = this.$refs.table.$el.getElementsByClassName("el-table__body")[0].style.width;
        this.width_box = this.$refs.table.$el.getElementsByClassName("el-table__body-wrapper")[0].offsetWidth;
        this.width_in = Number(width_t.replace(/px/g, ""));
        this.table_offsetLeft = this.$refs["base-table-list"].offsetLeft;
      });
    },
    onScroll(e) {
      this.$refs.table.$el.getElementsByClassName("el-table__body-wrapper")[0].scrollLeft = e.target.scrollLeft;
    },
    closeThisDialog(ref) {
      if (!this.isClickPopover || !this.$refs[this.isClickPopover]) {
        this.isClickPopover = ref;
      } else {
        this.$refs[this.isClickPopover].doClose();
        this.isClickPopover = ref;
      }
    },
  },
};
</script>
<style lang="scss">
.info-file-able {
  .item-box {
    // padding: 8px 0;
    .item-child {
      height: 40px;
      padding: 0 16px;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      margin: 4px 0;
      i {
        font-size: 14px;
      }
      &:hover {
        background: #f7f8f9;
        color: initial;
      }
      &:active {
        background-color: #ecedee;
        color: initial;
      }
      .icon {
        margin-right: 16px;
      }
    }
    .text-disable {
      color: rgba(32, 32, 40, 0.4) !important;
    }
    .item-child:first-child {
      margin-top: 8px;
    }
    .item-child:last-child {
      margin-bottom: 8px;
    }
    .del {
      color: #ff3939;
      &:hover {
        color: #ff3939;
      }
      &:active {
        color: #ff3939;
      }
    }
  }
}
.base-table-list {
  height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
  .el-table--scrollable-x {
    overflow-x: inherit;
    position: relative;
    + .my-scroll {
      display: block;
    }
  }
  .el-table--scrollable-x + .my-scroll {
    display: block;
  }
  .my-scroll {
    position: fixed;
    bottom: 0;
    height: 6px;
    z-index: 999;
    left: 0;
    right: 0;
    display: none;
    overflow: auto;
    margin: 0 auto;
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #ccc;
    }
    .my-scroll-in {
      height: 100%;
      height: 6px;
    }
  }
  .el-table::before {
    display: none;
  }
  .el-table__fixed::before {
    display: none;
  }
  .el-table__empty-block {
    min-height: 400px;
  }
  .el-table__append-wrapper {
    position: relative;
    box-sizing: border-box;
  }
  .el-table__body-wrapper {
    // min-height: 400px !important;
    // overflow: hidden !important;
    // height: auto !important;
    tbody tr td:first-child .cell {
      padding-left: 24px;
    }
  }
  .el-table__fixed-right {
    padding-bottom: 4px;
  }
  .el-table__fixed-right::before {
    display: none;
  }
  th, td {
    padding: 0 !important;
    .cell {
      height: 48px;
      display: flex !important;
      align-items: center;
      line-height: 1.3;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      box-sizing: border-box;
    }
  }
  .el-table__fixed {
    padding-bottom: 4px;
  }
  .hidden-select {
    .el-table-column--selection .cell {
      display: none;
    }
  }
  .can-view {
    flex: 1;
    width: 0;
    .tip-in {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
    }
    &:hover {
      span {
        color: $color-active !important;
      }
      cursor: pointer;
    }
  }
  .not-view {
    pointer-events: none;
    // cursor: auto !important;
    // .title-in-text {
    //   cursor: auto !important;
    // }
    // &:hover {
    //   cursor: auto !important;
    //   span {
    //     color: initial !important;
    //   }
    //   color: initial !important;
    // }
    // &:active {
    //   cursor: auto !important;
    //   span {
    //     color: initial !important;
    //   }
    //   color: initial !important;
    // }
  }
  .el-table--border {
    border-top: 0 none;
  }
  .can-view {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-start;
    img {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      margin-right: 10px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
    i {
      font-size: 15px;
      color: $color-active;
      flex-shrink: 0;
    }
    .star {
      width: 16px;
      height: 16px;
      margin: 0;
      margin-left: 16px;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    span {
      color: $color-active;
      cursor: pointer;
      flex-shrink: 0;
      &:active {
        color: $colorStatus_activeColor;
      }
    }
    span:not(:last-child) {
      margin-right: 40px;
    }
    .del {
      color: #ff3939;
    }
    .text-disable {
      color: rgba(32, 32, 40, 0.4) !important;
    }
  }
  .shard-loading-table {
    overflow: hidden;
    width: 100%;
    height: 60px;
    .el-loading-parent--relative {
      min-height: 60px;
    }
  }
  .shard-loading-table__box {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
    background-color: #fff;
  }
  .el-table-column--selection {
    .cell {
      padding: 0 0 !important;
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }
  // .has-gutter {
  //   // .el-table-column--selection .cell{
  //   //   display: none;

  //   // }
  //   th .cell {
  //     color: rgba(32, 32, 32, 0.6);
  //     font-size: 14px;
  //     font-weight: 400;
  //     height: 48px;
  //   }
  //   tr th:first-child .cell {
  //     padding-left: 24px;
  //   }
  // }
  .status {
    width: 50px;
    height: 20px;
    border-radius: 2px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  .btns-label {
    display: flex;
    align-items: center;
    > * {
      flex-shrink: 0;
    }
    .el-popover__reference {
      color: $color-active;
      cursor: pointer;
      flex-shrink: 0;
      &:active {
        color: $colorStatus_activeColor;
      }
    }
    .btns {
      width: 80px;
    }
  }
  .pagination-block {
    overflow: hidden;
    // height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    padding-top: 50px;
    padding-bottom: 24px;
    border-top: 1px solid #ebeef5;
  }
  .status {
    width: 50px;
    height: 20px;
    border-radius: 2px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  .type-3 {
    background-color: #ffe7e6;
    color: #ff3939;
  }
  .type-1 {
    background-color: #fff0d2;
    color: #ff8b23;
  }
  .type-2 {
    background-color: #edf7f4;
    color: $color-active;
  }
  .el-table th.el-table__cell.is-leaf,
  .el-table td.el-table__cell {
    border: 0 none;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: $color-active;
  }
  .el-table__body {
    font-size: 14px;
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: initial;
  }
  .file-table-loading {
    width: 16px;
  }
}
</style>
